<div class="flex-row justify-center text-center">
  <mat-icon [svgIcon]="'nuaxia:nosurveys'" style="width:200px;height:200px;"></mat-icon>
  <h1 class="text-2xl">No {{contentTypes}} available currently</h1>
  <p>We will regularly inform you about upcoming {{contentType}} opportunities.</p>
  <p>Keeping your profile up to date ensures that we provide you with the professionally most relevant content.</p>
</div>

